import { tns } from '../../../../../../node_modules/tiny-slider/src/tiny-slider';
// import tns_helpers from '../helpers/tiny-slider-helpers';


// Attempt to get the element using document.getElementById
const element = document.getElementById('testimonialslider');
const element2 = document.getElementById('testimonialslider-small');

// If it isn't "undefined" and it isn't "null", then it exists.
if (typeof (element) !== 'undefined' && element != null) {
	const els = document.querySelectorAll('[data-js=testimonialcarousel]');
	for (let i = els.length - 1; i >= 0; i -= 1) {
		const el = els[i];
		const tns_obj = tns({
			center: false,
			container: el,
			controls: false,
			nav: false,
			navPosition: 'bottom',
			prevButton: false,
			nextButton: false,
			items: 1,
			loop: true,
			slideBy: 1,
			touch: false,
			controlsText: ['', ''],
			mouseDrag: false,
			responsive: {
				950: {
					items: 2,
					controls: true,
					gutter: 5,
				},
				1375: {
					gutter: 1,
					items: 3,
				},
				1770: {
					gutter: 1,
					items: 4,
				},
			},
		});
		// a11y fix
		// tns_helpers.fix(tns_obj);

		tns_obj.getInfo();

		// custom nav buttons logic
		document.addEventListener('click', (e) => {
			let slideNum = null;

			if (!e.target.matches('.nav-button')) return;
			e.preventDefault();
			const buttonDir = e.target.getAttribute('data-controls');
			const findFocused = document.getElementsByClassName('focused');
			const firstFocused = findFocused[0];
			const parent = firstFocused.parentNode;
			const next = parent.nextElementSibling;
			const prev = parent.previousElementSibling;

			// remove focused class from all Nav Cards
			const navcards = document.getElementsByClassName('testimonialslider-navcard');
			[].forEach.call(navcards, (elem) => {
				elem.classList.remove('focused');
			});

			if (buttonDir === 'next') {
				if (next == null) {
					tns_obj.goTo('next');

					const activeNavCards = document.getElementsByClassName('tns-slide-active');
					const lastNavCard = activeNavCards[activeNavCards.length - 1];
					const lastChild = lastNavCard.firstElementChild;
					slideNum = lastChild.dataset.slidenum;

					lastChild.classList.add('focused');
				} else {
					const newFocused = next.firstElementChild;
					slideNum = newFocused.dataset.slidenum;

					if (!next.classList.contains('tns-slide-active')) {
						tns_obj.goTo('next');
					}

					newFocused.classList.add('focused');
				}
			} else if (buttonDir === 'prev') {
				if (prev == null) {
					tns_obj.goTo('prev');

					const activeNavCards = document.getElementsByClassName('tns-slide-active');
					const firstNavCard = activeNavCards[0];
					const firstChild = firstNavCard.firstElementChild;
					slideNum = firstChild.dataset.slidenum;

					firstChild.classList.add('focused');
				} else {
					const newFocused = prev.firstElementChild;
					slideNum = newFocused.dataset.slidenum;

					if (!prev.classList.contains('tns-slide-active')) {
						tns_obj.goTo('prev');
					}

					newFocused.classList.add('focused');
				}
			}
			// remove active-testimonial class from content
			const activeContents = document.getElementsByClassName('active-testimonial');
			const firstActive = activeContents[0];
			firstActive.classList.remove('active-testimonial');

			// add active-testimonial class to new content
			const newActive = document.getElementById(slideNum);
			newActive.className += ' active-testimonial';
		}, false);
	}

	// Add focused class to first nav slide on load
	const activeSlides = document.getElementsByClassName('tns-slide-active');
	const firstSlide = activeSlides[0];
	const firstChild = firstSlide.firstElementChild;
	firstChild.className += ' focused';

	// Remove all content except the first on load
	const contentElements = document.getElementsByClassName('testimonialslider-content');
	const requiredContentElement = contentElements[0];
	requiredContentElement.className += ' active-testimonial';

	// function to change content by selecting a slide
	document.addEventListener('click', (event) => {
		if (!event.target.matches('.testimonialslider-navcard')) return;
		event.preventDefault();

		const slideNum = event.target.dataset.slidenum;
		const targetEl = event.target;

		// remove active-testimonial class from content and add to new
		const activeContents = document.getElementsByClassName('active-testimonial');
		const firstActive = activeContents[0];
		firstActive.classList.remove('active-testimonial');
		const newActive = document.getElementById(slideNum);
		newActive.className += ' active-testimonial';

		// remove focused class from nav card and add to new
		const oldFocused = document.getElementsByClassName('focused');
		const old = oldFocused[0];
		old.classList.remove('focused');
		targetEl.className += ' focused';
	}, false);

	// prevent swipe action on mobile
	const slides = document.getElementsByClassName('testimonialslider-navcardcontainer'); // area we don't want touch drag
	const defaultPrevent = function (e) { e.preventDefault(); };
	for (let i = 0; i < slides.length; i += 1) {
		slides[i].addEventListener('touchstart', defaultPrevent);
		slides[i].addEventListener('touchmove', defaultPrevent);
	}
}


if (typeof (element2) !== 'undefined' && element2 != null) {

		// Add focused class to first nav slide on load
		const activeSlides = document.getElementsByClassName('testimonialslider-navcard');
		const firstSlide = activeSlides[0];
		firstSlide.className += ' focused';
	
		// Remove all content except the first on load
		const contentElements = document.getElementsByClassName('testimonialslider-content');
		const requiredContentElement = contentElements[0];
		requiredContentElement.className += ' active-testimonial';
	
		// function to change content by selecting a slide
		document.addEventListener('click', (event) => {
			if (!event.target.matches('.testimonialslider-navcard')) return;
			event.preventDefault();
	
			const slideNum = event.target.dataset.slidenum;
			const targetEl = event.target;
	
			// remove active-testimonial class from content and add to new
			const activeContents = document.getElementsByClassName('active-testimonial');
			const firstActive = activeContents[0];
			firstActive.classList.remove('active-testimonial');
			const newActive = document.getElementById(slideNum);
			newActive.className += ' active-testimonial';
	
			// remove focused class from nav card and add to new
			const oldFocused = document.getElementsByClassName('focused');
			const old = oldFocused[0];
			old.classList.remove('focused');
			targetEl.className += ' focused';
		}, false);
}
